import * as React from 'react';
import { IAboutTab } from '../../settings';
import { AboutTab as AboutTabComponent, AboutTabWithIcons } from '../../components/AboutTab';

interface IAboutTabProps {
  tab: IAboutTab;
  activeTab: string;
}

export function AboutTab({ tab, activeTab }: IAboutTabProps) {
  const componentMapper: Record<string, React.ReactElement> = React.useMemo(
    () => ({
      main: (
        <AboutTabComponent
          firstColumnParagraphs={tab.firstColumnParagraphs}
          secondColumnParagraphs={tab.secondColumnParagraphs}
        />
      ),
      facts: <AboutTabWithIcons icons={tab.icons || []} />,
      history: <AboutTabWithIcons icons={tab.icons || []} />,
    }),
    [tab.icons, tab.secondColumnParagraphs, tab.firstColumnParagraphs],
  );

  return componentMapper[activeTab] || null;
}
